import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

import { BundledProduct } from 'common/src/modules/products';
import { MetricConversionPipe } from 'common/src/modules/rnpl-common';
// import { ActionButtonsService } from 'common/src/services/action-buttons.service';

@Component({
  selector: 'rnpl-bundled-products-cards',
  templateUrl: './bundled-products-cards.component.html',
  styleUrls: ['./bundled-products-cards.component.scss']
})
export class BundledProductsCardsComponent implements OnChanges {

  public _quantityMultiplier = 1;

  @Input() public bundledProducts: BundledProduct[]|Partial<BundledProduct>[] = [];
  @Input() public isReadOnly = false;
  @Input() public editableQuantity = false;
  @Input() public showRemoveBtn = false;
  @Input() public showUnitPriceNet = false;
  @Input() public priceOptionNet = false;
  @Input() public priceOptionGross = false;
  @Input() public currencyIsOriginal = false;
  @Input() public priceFromBundledProducts = false;
  @Input() public currency: string = '€';
  @Input() public set quantityMultiplier(quantity: number|string) {
    if (quantity && +quantity) {
      this._quantityMultiplier = +quantity;
      return;
    }
    this._quantityMultiplier = 1;
  };

  @Output() quantityUpdatedEmit: EventEmitter<null> = new EventEmitter<null>();
  @Output() removeEmit: EventEmitter<BundledProduct> = new EventEmitter<BundledProduct>();
  @Output() priceChangedEmit: EventEmitter<{ fieldValue: number; fieldName: string; bundleId: number }>
    = new EventEmitter<{ fieldValue: number; fieldName: string; bundleId: number }>();

  // private destroy$: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor(
    private metricPipe: MetricConversionPipe
    // public actionButtonsService: ActionButtonsService,
    ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.hasOwnProperty('bundledProducts') && this.priceFromBundledProducts) {
      if (this.priceOptionNet) {
        this.bundledProducts = [...this.bundledProducts].map((bundledProduct: BundledProduct) => ({
          ...bundledProduct,
          netUnitPriceControl: this.getPriceControl(bundledProduct['netUnitPrice']),
          netTotalPriceControl: this.getPriceControl(bundledProduct['netTotalPrice']),
        }))
      }
      if (this.priceOptionGross) {
        this.bundledProducts = [...this.bundledProducts].map((bundledProduct: BundledProduct) => ({
          ...bundledProduct,
          grossUnitPriceControl: this.getPriceControl(bundledProduct['grossUnitPrice']),
          grossTotalPriceControl: this.getPriceControl(bundledProduct['grossTotalPrice']),
        }))
      }
    }
  }

  public getPriceControl(sourceValue: number): FormControl {
    const value = this.currencyIsOriginal
      ? sourceValue
      : (sourceValue || sourceValue === 0)
        ? (+sourceValue / 1e2).toFixed(2)
        : sourceValue;

    return new FormControl({ value, disabled: this.isReadOnly });
  }

  public quantityUpdated(): void {
    this.quantityUpdatedEmit.emit();
  }

  public remove(bundledProduct): void {
    this.removeEmit.emit(bundledProduct);
  }

  public updatePrice(priceValue: number, fieldName: string, bundledProductId: number): void {
    if (priceValue) {
      priceValue = this.currencyIsOriginal
        ? +priceValue
        : +this.metricPipe.transform(+priceValue, 'TO-INTEGER').toFixed(0);
    }
    this.priceChangedEmit.emit({ fieldValue: priceValue, fieldName, bundleId: bundledProductId });
  }

  //
  // ngOnDestroy(): void {
  //   this.destroy$.next(null);
  //   this.destroy$.complete();
  // }

}
